import { Company } from 'interfaces/company'
import BillingYourSubscription from './billing-your-subscription'
import BillingPaymentMethod from './billing-payment-method'
import BillingAddress from './billing-address'
import BillingHistory from './billing-history'
import { useState } from 'react'
import { Toaster } from 'lib/components/toast/toast'
import QueryClientProvider from 'providers/query-client-provider'
import { BillingPlansProvider } from './billing-plans-context'

const classNames = {
  cardItem: 'tw-mb-4 tw-flex tw-items-center tw-justify-between',
  cardWrapper: 'tw-w-1/2 tw-p-4 tw-block tw-overflow-x-auto tw-bg-white tw-rounded-lg tw-shadow-md',
  container: 'tw-container tw-px-3',
  header: 'tw-flex tw-justify-between tw-mb-4',
  wrapper: 'tw-container tw-px-3 tw-flex tw-w-full tw-flex-col',
}

export default function BillingPage({ currentCompany }: { currentCompany: Company }) {
  const [company, setCompany] = useState(currentCompany)

  return (
    <QueryClientProvider>
      <BillingPlansProvider company={company}>
        <Toaster />
        <div className={classNames.wrapper}>
          <div className={classNames.header}>
            <h4>Manage Your Subscription</h4>
          </div>
          <div className="tw-mb-4 tw-flex tw-justify-between tw-gap-4">
            <BillingYourSubscription company={company} />
            <div className="tw-flex tw-h-56 tw-w-full tw-flex-col tw-justify-between">
              <BillingPaymentMethod />
              <BillingAddress company={company} setCompany={setCompany} />
            </div>
          </div>
          <BillingHistory />
        </div>
      </BillingPlansProvider>
    </QueryClientProvider>
  )
}
